function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M8.512 23.737a1 1 0 0 1 1.203.042 9.99 9.99 0 0 0 2.649 1.54 1 1 0 0 1 .636.931V29a1 1 0 0 0 1 1h4a1 1 0 0 0 1-1v-2.75a1 1 0 0 1 .636-.931 9.989 9.989 0 0 0 2.65-1.542 1 1 0 0 1 1.203-.042l1.861 1.303a1 1 0 0 0 1.393-.245l2.294-3.277a1 1 0 0 0-.245-1.392l-2.477-1.735a1 1 0 0 1-.416-.96 10.094 10.094 0 0 0 0-2.854 1 1 0 0 1 .417-.96l2.476-1.734a1 1 0 0 0 .245-1.393l-2.294-3.276a1 1 0 0 0-1.393-.246l-1.858 1.301a1 1 0 0 1-1.203-.042 9.99 9.99 0 0 0-2.653-1.544A1 1 0 0 1 19 5.75V3a1 1 0 0 0-1-1h-4a1 1 0 0 0-1 1v2.75a1 1 0 0 1-.636.931 9.99 9.99 0 0 0-2.652 1.543 1 1 0 0 1-1.203.042l-1.856-1.3a1 1 0 0 0-1.392.246l-2.295 3.277a1 1 0 0 0 .246 1.392l2.472 1.732a1 1 0 0 1 .417.96 10.094 10.094 0 0 0 0 2.858 1 1 0 0 1-.416.96l-2.473 1.733a1 1 0 0 0-.246 1.392l2.295 3.277a1 1 0 0 0 1.392.245l1.86-1.301zm-.712 2.94a3 3 0 0 1-4.178-.737l-2.294-3.277a3 3 0 0 1 .737-4.178l1.984-1.39a12.14 12.14 0 0 1 0-2.186l-1.984-1.39a3 3 0 0 1-.737-4.178l2.294-3.276A3 3 0 0 1 7.8 5.328l1.26.882c.61-.434 1.26-.81 1.94-1.122V3a3 3 0 0 1 3-3h4a3 3 0 0 1 3 3v2.088c.681.313 1.331.69 1.942 1.123l1.261-.883a3 3 0 0 1 4.178.737l2.294 3.276a3 3 0 0 1-.736 4.179l-1.989 1.39a12.162 12.162 0 0 1 0 2.182l1.988 1.392a3 3 0 0 1 .736 4.178l-2.294 3.277a3 3 0 0 1-4.178.737l-1.264-.886c-.61.433-1.259.808-1.939 1.12V29a3 3 0 0 1-3 3h-4a3 3 0 0 1-3-3v-2.088a11.978 11.978 0 0 1-1.937-1.12l-1.263.885zM16 23a7 7 0 1 1 0-14 7 7 0 0 1 0 14zm0-2a5 5 0 1 0 0-10 5 5 0 0 0 0 10z"
});

var SvgSettings = function SvgSettings(props) {
  return React.createElement("svg", _extends({
    width: 32,
    height: 32,
    fill: "#1B1F23",
    viewBox: "0 0 32 32"
  }, props), _ref);
};

export default __webpack_public_path__ + "293f14f9a4b17c38084fbc739463df49.svg";
export { SvgSettings as ReactComponent };


//////////////////
// WEBPACK FOOTER
// ../icons/svg/settings.svg
// module id = null
// module chunks = 